<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 12 : 1"
      :disabled="$store.getters.isLoading || disable"
    >
      <v-expansion-panels focusable>
        <v-expansion-panel
          :v-ripple="!$store.getters.isLoading"
          readonly
          :class="{ active: active }"
          class="list-item"
          @click="$emit('click', false)"
        >
          <v-expansion-panel-header
            v-if="isReady && !$store.getters.isLoading"
            :disable-icon-rotate="disableRotate"
            :hide-actions="hideActions"
            class="list-item-height"
            ripple
          >
            <div v-if="showIcon" class="pr-4">
              <slot name="icon" />
            </div>

            <v-container fluid fill-height pa-0 ma-0>
              <v-row no-gutters>
                <slot name="body" />
              </v-row>
            </v-container>

            <template v-slot:actions>
              <slot name="actions" />
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-header
            v-else
            :disable-icon-rotate="disableRotate"
            :hide-actions="hideActions"
            class="list-item-height"
            ripple
          >
            <v-skeleton-loader type="list-item-avatar-two-line" />
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: "CardItemsComponents",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    disableRotate: {
      type: Boolean,
      default: true,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    isReady: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  background-color: white;
  border: solid;
  border-color: rgba(56, 56, 56, 0.2);
  border-width: 0.5px !important;
  border-radius: 5px;
}
.list-item.active {
  border-color: var(--v-primary-base) !important;
}
.list-item-height {
  height: 72px;
}
</style>
<style lang="scss">
.title-card-item-component {
  font-size: 1.2rem;
  color: #000 !important;
}
.subtitle-card-item-component {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6) !important;
}
.subtitle-card-item-component.error {
  font-size: 1rem;
  color: white !important;
  background-color: red;
  padding: 0 2px;
}
.title-header-card-item-component {
  font-size: 1.6rem;
  font-weight: 800;
}
</style>
